import request from '@/utils/request'

export default {
  getUserInfo(data) {
    return request({
      url: 'https://rs.yiigle.com/api/index/getUserInfo',
      method: 'post',
      data
    })
  },
}